<template>
  <div class="card">
    <div
      v-if="this.errosValidacaoGeral.length"
      class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
    >
      <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
        <inline-svg src="media/icons/duotune/general/gen044.svg" />
      </span>
      <div class="d-flex flex-stack flex-grow-1">
        <div class="fw-bold">
          <h4 class="text-gray-800 fw-bolder">Aviso</h4>
          <div class="fs-6 text-gray-600">
            <ul>
              <li v-for="value in this.errosValidacaoGeral" :key="value">
                {{ value }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <button
        type="button"
        class="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto"
        @click="this.errosValidacaoGeral = {}"
      >
        <span class="svg-icon svg-icon-2x">
          <img src="media/icons/duotune/arrows/arr088.svg" />
        </span>
      </button>
    </div>
    <div class="card-header">
      <h3 class="card-title">
        <img
          src="media/icons/duotune/abstract/abs039.svg"
          class="me-2"
        />Financeiro - Faturas
      </h3>
      <div
        v-if="this.modal === true"
        class="btn btn-icon btn-sm btn-active-light-primary mt-6"
        data-bs-dismiss="modal"
        @click="this.$emit('fecharFinanceiroLicencas', false)"
      >
        <span class="svg-icon svg-icon-2x">
          <img src="media/icons/duotune/arrows/arr061.svg" />
        </span>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <inline-svg src="media/icons/duotune/general/gen004.svg" />
            </span>
            <input
              id="txtPesquisar"
              type="text"
              v-model="tableData.search"
              @input="onInput"
              class="form-control form-control-solid w-250px ps-15"
              placeholder="Pesquisar"
            />
          </div>
        </div>
        <div
          v-if="
            checked.length === 0 &&
            this.user.User.TipoUsuario.tipo === 'Administrador'
          "
          class="card-toolbar flex-row-fluid justify-content-end gap-5"
        >
          <button
            v-if="this.adicionar"
            type="button"
            class="btn btn-sm btn-primary"
            @click="this.adicionarLicencaFatura()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/general/gen041.svg" /></span
            >Adicionar
          </button>
          <button
            type="button"
            class="btn btn-sm btn-light btn-active-light-primary"
            data-kt-menu-trigger="click"
            data-kt-menu-placement="bottom-end"
            data-kt-menu-flip="top-end"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/general/gen052.svg" />
            </span>
            <span class="svg-icon svg-icon-5 m-0">
              <inline-svg src="media/icons/duotune/arrows/arr072.svg" />
            </span>
          </button>
          <div
            class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4"
            data-kt-menu="true"
          >
            <div class="menu-item px-3">
              <a
                @click="this.gerarLicencas()"
                class="menu-link px-3 align-items-center"
              >
                <span class="svg-icon svg-icon-1 align-self-center">
                  <inline-svg
                    src="media/icons/duotune/finance/fin005.svg"
                    class="me-2"
                  />
                  Gerar Licenças
                </span>
              </a>
            </div>
            <div class="menu-item px-3">
              <a
                @click="this.solicitarMovimentacoes()"
                class="menu-link px-3 align-items-center"
              >
                <span class="svg-icon svg-icon-1 align-self-center">
                  <inline-svg
                    src="media/icons/duotune/files/fil021.svg"
                    class="me-2"
                  />
                  Movimentação
                </span>
              </a>
            </div>
            <div class="menu-item px-3">
              <a
                @click="this.$refs.table.exportarExcel()"
                class="menu-link px-3 align-items-center"
              >
                <span class="svg-icon svg-icon-1 align-self-center">
                  <inline-svg
                    src="media/icons/duotune/arrows/arr078.svg"
                    class="me-2"
                  />
                  Exportar
                </span>
              </a>
            </div>
          </div>
        </div>
        <div
          v-else
          class="card-toolbar flex-row-fluid justify-content-end gap-5"
          data-kt-customer-table-toolbar="selected"
        >
          <div
            class="fw-bolder me-5"
            v-if="this.user.User.TipoUsuario.tipo === 'Administrador'"
          >
            <span class="me-2">{{ checked.length }}</span
            >Selecionado(s)
          </div>
          <button
            v-if="
              this.excluir &&
              this.modal === false &&
              this.user.User.TipoUsuario.tipo === 'Administrador'
            "
            type="button"
            class="btn btn-sm btn-danger"
            @click="deleteSelecionados()"
          >
            Excluír Selecionado(s)
          </button>
        </div>
      </div>
      <div class="card-body pt-0">
        <Datatable
          ref="table"
          :table-header="tableHeader"
          :table-data="tableData"
          :table-pagination="tablePagination"
          :page-sizes="pageSizes"
          :enable-items-per-page-dropdown="true"
          :hide-on-single-page="false"
          empty-table-text="Nenhum registro foi encontrado"
          v-on:checked-rows="checked = $event"
          :colors="true"
          @aplicar-filtro="aplicarFiltroOData"
        >
          <template v-slot:cell-checkbox="{ row: data }">
            <div
              v-if="
                this.user.User.TipoUsuario.tipo === 'Administrador' &&
                (data.cancelado === '0' || data.baixa === '0')
              "
              class="form-check form-check-sm form-check-custom form-check-solid"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :value="data.id"
                v-model="checked"
              />
            </div>
          </template>
          <template v-slot:cell-id="{ row: data }">
            <CellWrapper :data="data">
              {{ data.id }}
            </CellWrapper>
          </template>
          <template v-slot:cell-nome="{ row: data }">
            <div class="min-w-150px align-middle">
              <div
                class="text-muted text-hover-primary fw-semibold text-muted d-block fs-9"
              >
                <CellWrapper :data="data">
                  <span>
                    {{ getDescricaoRelacionado(data) }}
                  </span>
                </CellWrapper>
              </div>
              <div class="text-gray-900 fw-bold text-hover-primary mb-1 fs-6">
                <CellWrapper :data="data">
                  <span>
                    {{ getNomeRelacionado(data) }}
                  </span>
                </CellWrapper>
              </div>
              <div
                class="text-muted text-hover-primary fw-semibold text-muted d-block fs-7"
              >
                <CellWrapper :data="data">
                  <span>
                    {{
                      this.$utils.setMask(
                        getDocumentoRelacionado(data),
                        "##.###.###/####-##",
                        true
                      )
                    }}
                  </span>
                </CellWrapper>
              </div>
            </div>
          </template>
          <template v-slot:cell-descricao="{ row: data }">
            <div
              class="min-w-150px text-gray-800 text-muted text-hover-primary fw-semibold text-muted d-block fs-7"
            >
              <CellWrapper :data="data">
                <div>
                  {{ data.descricao }}
                </div>
              </CellWrapper>
            </div>
            <div
              class="text-muted text-hover-primary fw-semibold text-muted d-block fs-8"
            >
              <CellWrapper :data="data">
                <span>
                  {{ data.observacoes }}
                </span>
              </CellWrapper>
            </div>
          </template>
          <template v-slot:cell-emissao="{ row: data }">
            <div class="min-w-100px">
              <CellWrapper :data="data">
                <div>
                  {{ this.$utils.formatarData(data.emissao) }}
                </div>
              </CellWrapper>
            </div>
          </template>
          <template v-slot:cell-vencimento="{ row: data }">
            <div
              class="min-w-100px text-gray-900 fw-bold text-hover-primary d-block mb-1 fs-6"
            >
              <CellWrapper :data="data">
                <div>
                  {{ this.$utils.formatarData(data.vencimento) }}
                </div>
              </CellWrapper>
            </div>
          </template>
          <template v-slot:cell-valor="{ row: data }">
            <div
              class="text-end min-w-100px text-gray-900 fw-bold text-hover-primary d-block mb-1 fs-6"
            >
              <CellWrapper :data="data">
                <div>
                  {{ this.$utils.formatarNumero(data.valor) }}
                </div>
              </CellWrapper>
            </div>
          </template>
          <template v-slot:cell-valor_recebido="{ row: data }">
            <div
              class="text-end min-w-100px text-gray-900 fw-bold text-hover-primary d-block mb-1 fs-6"
            >
              <CellWrapper :data="data">
                <div>
                  {{ this.$utils.formatarNumero(data.valor_recebido) }}
                </div>
                <span
                  v-if="data.pagamento && data.pagamento !== null"
                  class="text-end text-muted text-hover-primary fw-semibold text-muted d-block fs-8"
                >
                  {{
                    this.$utils.formatarData(data.pagamento) +
                    " - " +
                    data.especie
                  }}
                </span>
              </CellWrapper>
            </div>
          </template>
          <template v-slot:cell-status="{ row: data }">
            <span :class="[getStatusColor(data).badge]">{{
              getStatusColor(data).descricao
            }}</span>
          </template>
          <template v-slot:cell-acoes="{ row: data }">
            <div
              v-if="this.user.User.TipoUsuario.tipo === 'Administrador'"
              class="d-flex flex-row-fluid justify-content-end flex-shrink-0 gap-3"
            >
              <button
                v-if="
                  this.receber === true &&
                  data.valor_recebido <= 0 &&
                  data.baixa !== '1' &&
                  data.cancelado !== '1'
                "
                type="button"
                class="btn btn-icon btn-sm btn-bg-light btn-active-warning"
                @click="receberFatura(data)"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Receber Fatura"
              >
                <span class="svg-icon svg-icon-1">
                  <inline-svg src="media/icons/duotune/finance/fin007.svg" />
                </span>
              </button>
              <button
                v-if="this.modal === false"
                class="btn btn-sm btn-light btn-active-light-primary"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end"
                data-kt-menu-flip="top-end"
              >
                Ações
                <span class="svg-icon svg-icon-5 m-0">
                  <inline-svg src="media/icons/duotune/arrows/arr072.svg" />
                </span>
              </button>
              <button
                v-else
                class="btn btn-sm btn-light-primary"
                @click="selecionarRegistro(data)"
              >
                Selecionar
              </button>
              <div
                v-if="this.editar || this.excluir || this.estornar"
                class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-150px py-4"
                data-kt-menu="true"
              >
                <div
                  v-if="
                    this.editar &&
                    data.valor_recebido <= 0 &&
                    data.baixa !== '1' &&
                    data.cancelado !== '1'
                  "
                  class="menu-item px-3"
                >
                  <a @click="editarRegistro(data.id)" class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/art/art005.svg"
                        class="me-2"
                      />Editar
                    </span></a
                  >
                </div>
                <div
                  v-if="
                    this.excluir &&
                    data.valor_recebido <= 0 &&
                    data.baixa !== '1' &&
                    data.cancelado !== '1'
                  "
                  class="menu-item px-3"
                >
                  <a @click="removerRegistro(data)" class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/arrows/arr015.svg"
                        class="me-2"
                      />Excluir
                    </span></a
                  >
                </div>
                <div
                  v-if="this.estornar && data.valor_recebido > 0"
                  class="menu-item px-3"
                >
                  <a @click="estornarRegistro(data)" class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/arrows/arr059.svg"
                        class="me-2"
                      />Estornar
                    </span></a
                  >
                </div>
                <div
                  v-if="
                    data.valor_recebido <= 0 &&
                    data.guid_boleto !== null &&
                    data.guid_boleto.length > 0 &&
                    data.baixa !== '1' &&
                    data.cancelado !== '1'
                  "
                  class="menu-item px-3"
                >
                  <a @click="baixarBoleto(data)" class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/files/fil007.svg"
                        class="me-2"
                      />Baixar boleto
                    </span></a
                  >
                </div>
              </div>
            </div>
            <div
              v-else
              class="d-flex flex-row-fluid justify-content-end flex-shrink-0 gap-3"
            >
              <button
                v-if="
                  data.valor_recebido <= 0 &&
                  data.guid_boleto &&
                  data.guid_boleto !== null &&
                  data.baixa !== '1' &&
                  data.cancelado !== '1'
                "
                type="button"
                class="btn btn-sm btn-light btn-active-primary"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Imprimir Boleto"
                @click="this.imprimirBoleto(data)"
              >
                <span class="svg-icon svg-icon-1">
                  <inline-svg src="media/icons/duotune/ecommerce/ecm010.svg" />
                  Boleto
                </span>
              </button>
              <button
                v-if="
                  data.valor_recebido <= 0 &&
                  data.baixa !== '1' &&
                  data.cancelado !== '1'
                "
                type="button"
                class="btn btn-sm btn-light btn-active-warning"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Realizar o pagamento da fatura"
                @click="exibirModalPagamento(data)"
              >
                <span class="svg-icon svg-icon-1">
                  <inline-svg src="media/icons/duotune/finance/fin002.svg" />
                  Pagar
                </span>
              </button>
            </div>
          </template>
        </Datatable>
      </div>
      <div class="card-footer">
        <div class="row">
          <div
            class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-4"
          >
            <div
              class="border border-success bg-light-success rounded py-3 px-6 mb-3"
            >
              <div class="d-flex align-items-center">
                <span class="svg-icon svg-icon-5 svg-icon-success me-2">
                  <inline-svg src="media/icons/duotune/arrows/arr066.svg" />
                </span>
                <div v-bind:data-kt-indicator="this.loading ? 'on' : 'off'">
                  <span class="indicator-progress">
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-1"
                    ></span>
                    Carregando...
                  </span>
                </div>
                <div v-if="!this.loading" class="fs-2 fw-bold">
                  {{
                    "R$ " + this.$utils.formatarNumero(this.totalValorRecebido)
                  }}
                </div>
              </div>
              <div
                v-if="this.user.User.TipoUsuario.tipo === 'Administrador'"
                class="fw-semibold fs-6 text-gray-600"
              >
                Total Recebido
              </div>
              <div v-else class="fw-semibold fs-6 text-gray-600">
                Total Pago
              </div>
            </div>
          </div>
          <div
            class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-4"
          >
            <div
              class="border border-warning bg-light-warning rounded py-3 px-6 mb-3"
            >
              <div class="d-flex align-items-center">
                <span class="svg-icon svg-icon-5 svg-icon-warning me-2">
                  <inline-svg src="media/icons/duotune/arrows/arr033.svg" />
                </span>
                <div v-bind:data-kt-indicator="this.loading ? 'on' : 'off'">
                  <span class="indicator-progress">
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-1"
                    ></span>
                    Carregando...
                  </span>
                </div>
                <div v-if="!this.loading" class="fs-2 fw-bold">
                  {{
                    "R$ " + this.$utils.formatarNumero(this.totalValorReceber)
                  }}
                </div>
              </div>
              <div
                v-if="this.user.User.TipoUsuario.tipo === 'Administrador'"
                class="fw-semibold fs-6 text-gray-600"
              >
                Total a Receber
              </div>
              <div v-else class="fw-semibold fs-6 text-gray-600">
                Total a Pagar
              </div>
            </div>
          </div>
          <div
            class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-4"
          >
            <div
              class="border border-danger bg-light-danger rounded py-3 px-6 mb-3"
            >
              <div class="d-flex align-items-center">
                <span class="svg-icon svg-icon-5 svg-icon-danger me-2">
                  <inline-svg src="media/icons/duotune/arrows/arr068.svg" />
                </span>
                <div v-bind:data-kt-indicator="this.loading ? 'on' : 'off'">
                  <span class="indicator-progress">
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-1"
                    ></span>
                    Carregando...
                  </span>
                </div>
                <div v-if="!this.loading" class="fs-2 fw-bold">
                  {{
                    "R$ " + this.$utils.formatarNumero(this.totalValorVencidas)
                  }}
                </div>
              </div>
              <div
                v-if="this.user.User.TipoUsuario.tipo === 'Administrador'"
                class="fw-semibold fs-6 text-gray-600"
              >
                Total Vencidas
              </div>
              <div v-else class="fw-semibold fs-6 text-gray-600">
                Total Vencidas
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <LoadingModal
    :nomeRef="'loadingModalLicencaRecebivel'"
    :mensagem="this.mensagemLoading"
    v-if="this.loadingModal === true"
  ></LoadingModal>
  <EditarFaturaModal
    v-if="exibirModalEditarLicencaFatura"
    :id="this.idLicencaFatura"
    @exibirEditarLicencaFaturaModal="exibirEditarLicencaFaturaModal"
    @confirmarEditarLicencaFaturaModal="confirmarEditarLicencaFaturaModal"
  ></EditarFaturaModal>
  <ReceberFaturaModal
    v-if="exibirModalReceberLicencaFatura"
    :id="this.idLicencaFatura"
    @exibirReceberLicencaFaturaModal="exibirReceberLicencaFaturaModal"
    @confirmarReceberLicencaFaturaModal="confirmarReceberLicencaFaturaModal"
  >
  </ReceberFaturaModal>
  <OpcoesPagamentoModal
    v-if="exibirModalOpcoesPagamento"
    :id="this.idLicencaFatura"
    @exibirOpcoesPagamentoModal="exibirOpcoesPagamentoModal"
    @confirmarOpcoesPagamentoModal="confirmarOpcoesPagamentoModal"
  >
  </OpcoesPagamentoModal>
  <ViewFilePDF
    v-if="exibirImpressaoPDF"
    :show="exibirImpressaoPDF"
    :documento="documentoImpressao"
    :dadosEmail="dadosEmail"
    @exibirModalImpressao="exibirModalImpressao"
  ></ViewFilePDF>
  <SolicitarMovimentacaoModal
    v-if="exibirModalSolicitarMovimentacoes"
    @exibirSolicitarMovimentacaoModal="exibirSolicitarMovimentacaoModal"
    @confirmarSolicitarMovimentacaoModal="confirmarSolicitarMovimentacaoModal"
  >
  </SolicitarMovimentacaoModal>
</template>

<script>
import { MenuComponent } from "@/assets/ts/components";
import { getOrCreateInstanceModal, hideModalId } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
import moment from "moment";
import EditarFaturaModal from "@/views/licencarecebivel/EditarFaturaModal.vue";
import ReceberFaturaModal from "@/views/licencarecebivel/ReceberFaturaModal.vue";
import OpcoesPagamentoModal from "@/views/licencarecebivel/OpcoesPagamentoModal.vue";
import ViewFilePDF from "@/components/modals/general/ViewFilePDF";
import SolicitarMovimentacaoModal from "@/views/licencarecebivel/SolicitarMovimentacaoModal.vue";
import CellWrapper from "@/components/wrapper/CellWrapper.vue";
const toast = useToast();

export default {
  emits: ["selecionarFinanceiroLicencas", "fecharFinanceiroLicencas"],
  components: {
    Datatable,
    LoadingModal,
    EditarFaturaModal,
    ReceberFaturaModal,
    OpcoesPagamentoModal,
    ViewFilePDF,
    SolicitarMovimentacaoModal,
    CellWrapper,
  },
  props: {
    modal: { type: Boolean, required: false, default: false },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    loadData() {
      this.tableData.search = "";
      this.tablePagination.page = 1;
      this.tablePagination.rowsPerPage = 10;
      this.$refs.table.setRowsPage(10);
      this.tableData.filterOData = "";
      this.$refs.table.load();
    },

    onInput() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        this.onSearch(this.tableData.search);
      }, this.doneTypingInterval);
    },

    async onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=(contains(descricao, '" +
          pesquisa +
          "') or contains(Revenda/nome, '" +
          pesquisa +
          "') or contains(Revenda/cnpj, '" +
          this.$utils.unMask(pesquisa) +
          "') or contains(Revenda/fantasia, '" +
          pesquisa +
          "') or contains(Emitente/nome, '" +
          pesquisa +
          "') or contains(Emitente/cnpj, '" +
          this.$utils.unMask(pesquisa) +
          "') or contains(Emitente/fantasia, '" +
          pesquisa +
          "') or contains(Distribuidor/nome, '" +
          pesquisa +
          "') or contains(Distribuidor/cnpj, '" +
          this.$utils.unMask(pesquisa) +
          "') or contains(Distribuidor/fantasia, '" +
          pesquisa +
          "') or contains(DistribuidorMaster/nome, '" +
          pesquisa +
          "') or contains(DistribuidorMaster/cnpj, '" +
          this.$utils.unMask(pesquisa) +
          "') or contains(DistribuidorMaster/fantasia, '" +
          pesquisa +
          "') ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or id eq " + pesquisa;
        }
        this.tableData.filterOData += ")";
      } else {
        this.tableData.filterOData = "";
      }
      this.filtroAplicado = this.tableData.filterOData;
      await this.totalizarFaturas();
    },

    async deleteSelecionados() {
      var alert = await Swal.fire({
        text: "Deseja remover os registros selecionados?",
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Sim, remova!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
      });
      if (alert.isConfirmed) {
        this.errosValidacaoGeral = [];
        this.excluiu = true;
        this.$refs.table.setLoading(true);
        for (var i = 0; i < this.checked.length; i++) {
          await this.excluirFinanceiroLicenca(this.checked[i]);
        }
        if (this.excluiu === true) {
          toast.success("Registros excluídos com sucesso!", {
            timeout: 3000,
          });
        }
        this.$refs.table.load();
        await this.totalizarFaturas();
      }
    },

    async removerRegistro(data) {
      if (
        data.valor_recebido <= 0 &&
        this.user.User.TipoUsuario.tipo === "Administrador" &&
        data.cancelado === "0" &&
        data.baixa === "0"
      ) {
        var alert = await Swal.fire({
          text: "Deseja remover o registro?",
          icon: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sim, remova!",
          cancelButtonText: "Cancelar",
          customClass: {
            confirmButton: "btn fw-bold btn-primary",
            cancelButton: "btn fw-bold btn-danger",
          },
        });
        if (alert.isConfirmed) {
          this.errosValidacaoGeral = [];
          this.excluiu = true;
          this.$refs.table.setLoading(true);
          await this.excluirFinanceiroLicenca(data.id);
          if (this.excluiu === true) {
            toast.success("Registro excluído com sucesso!", {
              timeout: 3000,
            });
          }
          this.$refs.table.load();
          await this.totalizarFaturas();
        }
      } else {
        await Swal.fire({
          text: "Não é possível remover uma fatura já recebida!",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn fw-bold btn-warning",
          },
        });
      }
    },

    async estornarRegistro(data) {
      if (
        data.valor_recebido > 0 &&
        this.user.User.TipoUsuario.tipo === "Administrador"
      ) {
        var alert = await Swal.fire({
          text: "Deseja estornar o recebimento do registro?",
          icon: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sim, estorne!",
          cancelButtonText: "Cancelar",
          customClass: {
            confirmButton: "btn fw-bold btn-primary",
            cancelButton: "btn fw-bold btn-danger",
          },
        });
        if (alert.isConfirmed) {
          let estornou = false;
          await this.exibirModalLoading(true);
          this.errosValidacaoGeral = [];
          try {
            let ret = await this.$store.dispatch(
              "licencaRecebivel/getLicencaRecebivel",
              data.id
            );

            if (ret.Success === true) {
              let licencaFatura = ret.Data;
              licencaFatura.pagamento = null;
              licencaFatura.valor_recebido = 0;
              licencaFatura.data_recebimento = null;
              licencaFatura.id_usuario_recebeu = null;
              licencaFatura.especie = null;

              licencaFatura.Emitente = null;
              licencaFatura.Revenda = null;
              licencaFatura.Distribuidor = null;
              licencaFatura.DistribuidorMaster = null;

              let formData = this.$utils.convertModelToFormData(licencaFatura);
              let retPut = await this.$store.dispatch(
                "licencaRecebivel/putLicencaRecebivel",
                formData
              );
              if (retPut.Success === true) {
                estornou = true;
              }
            }
          } catch (error) {
            console.log(error);
          }

          this.$refs.table.setLoading(true);
          if (estornou === true) {
            toast.success("Estorno realizado com sucesso!", {
              timeout: 3000,
            });
          }
          this.$refs.table.load();
          await this.totalizarFaturas();
          await this.exibirModalLoading(false);
        }
      } else {
        await Swal.fire({
          text: "Não é possível estornar o registro!",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn fw-bold btn-warning",
          },
        });
      }
    },

    async excluirFinanceiroLicenca(id) {
      try {
        await this.$store.dispatch(
          "licencaRecebivel/deleteLicencaRecebivel",
          id
        );
      } catch (error) {
        this.excluiu = false;
        this.errosValidacaoGeral.push(error.Message);
      }
    },

    editarRegistro(id) {
      this.idLicencaFatura = id;
      this.exibirEditarLicencaFaturaModal(true);
    },

    selecionarRegistro(registro) {
      this.$emit("selecionarFinanceiroLicencas", registro);
    },

    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },

    async verificarRestricoes() {
      if (this.user.User.TipoUsuario.Restricao != null) {
        this.user.User.TipoUsuario.Restricao.find((element) => {
          if (element.regra === "Permitir.LicencaRecebivel.Incluir") {
            this.adicionar = true;
          }
          if (element.regra === "Permitir.LicencaRecebivel.Alterar") {
            this.editar = true;
          }
          if (element.regra === "Permitir.LicencaRecebivel.Excluir") {
            this.excluir = true;
          }
          if (element.regra === "Permitir.LicencaRecebivel.Receber") {
            this.receber = true;
          }
          if (element.regra === "Permitir.LicencaRecebivel.Estornar") {
            this.estornar = true;
          }
        });
      }
    },

    async gerarLicencas() {
      try {
        var alert = await Swal.fire({
          text: "Deseja gerar as licenças referentes ao mês passado?",
          icon: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          customClass: {
            confirmButton: "btn fw-bold btn-primary",
            cancelButton: "btn fw-bold btn-danger",
          },
        });
        if (alert.isConfirmed) {
          await this.exibirModalLoading(true);
          this.mensagemLoading = "Aguarde, gerando faturas...";
          let result = await this.$store.dispatch(
            "licencaRecebivel/postGerarFaturaLicencas",
            null
          );

          if (result) {
            if (result.Success) {
              if (result.Success === true) {
                toast.success(result.Message, {
                  timeout: 3000,
                });
                this.atualizarTabela();
              } else {
                toast.error(result.Message, {
                  timeout: 3000,
                });
              }
            }
          }
        }
      } catch (error) {
        console.log(error);
        toast.error(error, {
          timeout: 3000,
        });
      }
      await this.exibirModalLoading(false);
    },

    async exibirModalLoading(exibir) {
      if (exibir === true) {
        this.loadingModal = true;
        await this.sleep(100);
        getOrCreateInstanceModal("loadingModalLicencaRecebivel");
      } else {
        await this.sleep(500);
        hideModalId("loadingModalLicencaRecebivel");
        await this.sleep(100);
        this.loadingModal = false;
      }
    },

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    getStatusColor(data) {
      let retorno = {};
      const dataAtual = moment();
      const dataVencimento = moment(data.vencimento);
      if (data.valor_recebido > 0) {
        retorno = {
          descricao: "Recebida",
          badge: "badge badge-light-success fs-7 fw-bold",
        };
      } else if (
        data.valor_recebido <= 0 &&
        dataVencimento.isBefore(dataAtual)
      ) {
        retorno = {
          descricao: "Vencida",
          badge: "badge badge-light-danger fs-7 fw-bold",
        };
      } else if (
        data.valor_recebido <= 0 &&
        dataVencimento.isAfter(dataAtual)
      ) {
        retorno = {
          descricao: "Pendente",
          badge: "badge badge-light-warning fs-7 fw-bold",
        };
      } else {
        retorno = {
          descricao: "Aguardando",
          badge: "badge badge-light-primary fs-7 fw-bold",
        };
      }
      if (data.cancelado === "1") {
        retorno = {
          descricao: "Cancelada",
          badge: "badge badge-light-info fs-7 fw-bold",
        };
      }
      if (data.baixa === "1") {
        retorno = {
          descricao: "Boleto baixado",
          badge: "badge badge-light-info fs-7 fw-bold",
        };
      }
      return retorno;
    },

    async confirmarEditarLicencaFaturaModal() {
      await this.atualizarTabela();
      this.exibirModalEditarLicencaFatura = false;
    },

    exibirEditarLicencaFaturaModal(exibir) {
      this.exibirModalEditarLicencaFatura = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_licenca_fatura_editar");
        }, 100);
      }
    },

    async adicionarLicencaFatura() {
      this.idLicencaFatura = -1;
      this.exibirEditarLicencaFaturaModal(true);
    },

    getDescricaoRelacionado(data) {
      if (data.Revenda) {
        return "Revenda";
      } else if (data.Emitente) {
        return "Emitente";
      } else if (data.Distribuidor) {
        return "Distribuidor";
      } else if (data.DistribuidorMaster) {
        return "Distribuidor Master";
      } else {
        return "";
      }
    },

    getNomeRelacionado(data) {
      if (data.Revenda) {
        return data.Revenda.nome;
      } else if (data.Emitente) {
        return data.Emitente.nome;
      } else if (data.Distribuidor) {
        return data.Distribuidor.nome;
      } else if (data.DistribuidorMaster) {
        return data.DistribuidorMaster.nome;
      } else {
        return "";
      }
    },

    getDocumentoRelacionado(data) {
      if (data.Revenda) {
        return data.Revenda.cnpj;
      } else if (data.Emitente) {
        return data.Emitente.cnpj;
      } else if (data.Distribuidor) {
        return data.Distribuidor.cnpj;
      } else if (data.DistribuidorMaster) {
        return data.DistribuidorMaster.cnpj;
      } else {
        return "";
      }
    },

    async receberFatura(data) {
      this.idLicencaFatura = data.id;
      this.exibirReceberLicencaFaturaModal(true);
    },

    async confirmarReceberLicencaFaturaModal() {
      await this.atualizarTabela();
      this.exibirModalReceberLicencaFatura = false;
    },

    exibirReceberLicencaFaturaModal(exibir) {
      this.exibirModalReceberLicencaFatura = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_licenca_fatura_receber");
        }, 100);
      }
    },

    async atualizarTabela() {
      this.$refs.table.setLoading(true);
      this.$refs.table.load();
      await this.totalizarFaturas();
    },

    async totalizarFaturas() {
      try {
        this.loading = true;
        this.totalValorRecebido = 0;
        this.totalValorReceber = 0;
        this.totalValorVencidas = 0;

        let filtro = this.filtroAplicado;
        if (filtro && filtro !== "") {
          filtro = filtro.replace("&$filter=", "filter(");
        }

        //Recebidas
        let consulta =
          "?$apply=aggregate(valor_recebido with sum as total_valor_recebido)";

        if (filtro && filtro !== "") {
          consulta =
            "?$apply=" +
            filtro +
            ")/aggregate(valor_recebido with sum as total_valor_recebido)";
        }

        let resultRecebido = await this.$store.dispatch(
          "licencaRecebivel/getLicencaRecebivelOData",
          consulta
        );

        if (
          resultRecebido &&
          resultRecebido !== null &&
          resultRecebido.length > 0 &&
          resultRecebido[0].total_valor_recebido
        ) {
          this.totalValorRecebido = resultRecebido[0].total_valor_recebido;
        }

        var dataAtual = new Date();
        var dataFormatada = dataAtual.toISOString().split("T")[0];

        //A receber
        consulta =
          "?$apply=filter((vencimento ge " +
          dataFormatada +
          ") and (valor_recebido le 0 and pagamento eq null))/aggregate(valor with sum as total_valor)";

        if (filtro && filtro !== "") {
          consulta =
            "?$apply=" +
            filtro +
            " and " +
            "(vencimento ge " +
            dataFormatada +
            ") and (valor_recebido le 0 and pagamento eq null))" +
            "/aggregate(valor with sum as total_valor)";
        }

        let resultReceber = await this.$store.dispatch(
          "licencaRecebivel/getLicencaRecebivelOData",
          consulta
        );

        if (
          resultReceber &&
          resultReceber !== null &&
          resultReceber.length > 0 &&
          resultReceber[0].total_valor
        ) {
          this.totalValorReceber = resultReceber[0].total_valor;
        }

        //Vencidas
        consulta =
          "?$apply=filter((vencimento le " +
          dataFormatada +
          ") and (valor_recebido le 0 and pagamento eq null))/aggregate(valor with sum as total_valor)";

        if (filtro && filtro !== "") {
          consulta =
            "?$apply=" +
            filtro +
            " and " +
            "(vencimento le " +
            dataFormatada +
            ") and (valor_recebido le 0 and pagamento eq null))" +
            "/aggregate(valor with sum as total_valor)";
        }

        let resultVencidas = await this.$store.dispatch(
          "licencaRecebivel/getLicencaRecebivelOData",
          consulta
        );

        if (
          resultVencidas &&
          resultVencidas !== null &&
          resultVencidas.length > 0 &&
          resultVencidas[0].total_valor
        ) {
          this.totalValorVencidas = resultVencidas[0].total_valor;
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    },

    async aplicarFiltroOData(filtro, expandFiltro) {
      this.filtroAplicado = filtro;
      await this.totalizarFaturas();
    },

    async confirmarOpcoesPagamentoModal() {
      await this.atualizarTabela();
      this.exibirModalOpcoesPagamento = false;
    },

    exibirOpcoesPagamentoModal(exibir) {
      this.exibirModalOpcoesPagamento = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_opcoes_pagamento_modal");
        }, 100);
      }
    },

    async exibirModalPagamento(data) {
      this.idLicencaFatura = data.id;
      this.exibirOpcoesPagamentoModal(true);
    },

    async imprimirBoleto(data) {
      try {
        await this.exibirModalLoading(true);
        let ret = await this.$store.dispatch(
          "boletoLicencaRecebivel/getBoletoLicencaRecebivelOData",
          "?$select=base64PDF&$filter=id_licenca_recebivel eq " + data.id
        );

        if (ret.value !== null && ret.value.length > 0) {
          this.documentoImpressao = this.$utils.base64ToBlob(
            ret.value[0].base64PDF
          );
          this.exibirImpressaoPDF = true;
          this.dadosEmail.anexosEmail = [
            { nome: "Boleto.pdf", base64Arquivo: ret.value[0].base64PDF },
          ];

          await this.exibirModalLoading(false);
          await this.exibirModalImpressao(true);
        }
      } catch (error) {
        console.log(error);
      }
      await this.exibirModalLoading(false);
    },

    async exibirModalImpressao(exibir) {
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_view_file_pdf");
        }, 100);
      } else {
        await new Promise(
          () => setTimeout(hideModalId("kt_modal_view_file_pdf"), 100),
          (this.documentoImpressao = []),
          (this.exibirImpressaoPDF = exibir)
        );
      }
    },

    async confirmarSolicitarMovimentacaoModal() {
      await this.atualizarTabela();
      this.exibirModalSolicitarMovimentacoes = false;
    },

    exibirSolicitarMovimentacaoModal(exibir) {
      this.exibirModalSolicitarMovimentacoes = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_solicitar_movimentacao_boleto");
        }, 100);
      }
    },

    async solicitarMovimentacoes() {
      this.exibirSolicitarMovimentacaoModal(true);
    },

    async baixarBoleto(data) {
      var alert = await Swal.fire({
        text: "Deseja realizar a baixa do boleto no banco?",
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Sim!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
      });
      if (alert.isConfirmed) {
        try {
          await this.exibirModalLoading(true);

          this.mensagemLoading = "Aguarde, realizando a baixa do título...";
          let result = await this.$store.dispatch(
            "licencaRecebivel/postBaixarBoleto",
            data.id
          );

          if (result.Success === true) {
            await Swal.fire({
              text: result.Message,
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn fw-bold btn-success",
              },
            });
            await this.atualizarTabela();
          } else {
            if (result.Message) {
              await Swal.fire({
                text: result.Message,
                icon: "warning",
                buttonsStyling: false,
                confirmButtonText: "OK",
                customClass: {
                  confirmButton: "btn fw-bold btn-warning",
                },
              });
            }
          }
        } catch (error) {
          console.log(error);
        }
        await this.exibirModalLoading(false);
      }
    },
  },
  async mounted() {
    setTimeout(() => {
      this.nextFocus("txtPesquisar");
    }, 500);
    await this.verificarRestricoes();
    await this.totalizarFaturas();
    setTimeout(MenuComponent.reinitialization, 500);
  },
  data() {
    return {
      adicionar: false,
      editar: false,
      excluir: false,
      receber: false,
      estornar: false,
      checked: [],
      errosValidacaoGeral: [],
      excluiu: true,
      loading: false,
      mensagemLoading: "",
      idLicencaFatura: -1,
      exibirModalEditarLicencaFatura: false,
      exibirModalReceberLicencaFatura: false,
      totalValorRecebido: 0,
      totalValorReceber: 0,
      totalValorVencidas: 0,
      filtroAplicado: "",
      typingTimer: null,
      doneTypingInterval: 500,
      loadingModal: false,
      exibirModalOpcoesPagamento: false,
      documentoImpressao: null,
      exibirImpressaoPDF: false,
      dadosEmail: {},
      exibirModalSolicitarMovimentacoes: false,
      tableHeader: [
        {
          type: "checkbox",
          key: "checkbox",
          sortable: false,
        },
        {
          name: "ID",
          key: "id",
          sortable: true,
        },
        {
          name: "Nome",
          key: "nome",
          sortable: false,
          sortingField: "Revenda/nome",
        },
        {
          name: "Descrição",
          key: "descricao",
          sortable: true,
        },
        {
          name: "Emissão",
          key: "emissao",
          sortable: true,
        },
        {
          name: "Vencimento",
          key: "vencimento",
          sortable: true,
        },
        {
          name: "Valor",
          key: "valor",
          sortable: true,
        },
        {
          name: "Valor Recebido",
          key: "valor_recebido",
          sortable: true,
        },
        {
          name: "Status",
          key: "status",
          sortable: false,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "licencaRecebivel/getLicencaRecebivelOData",
        selectOData:
          "?$select=id,descricao,emissao,vencimento,pagamento,valor,valor_recebido,observacoes,especie,guid_boleto,baixa,cancelado&$expand=Revenda($select=id,nome,cnpj)&$expand=Emitente($select=id,nome,cnpj)&$expand=Distribuidor($select=id,nome,cnpj)&$expand=DistribuidorMaster($select=id,nome,cnpj)",
        filterOData: "",
        search: "",
        defaultSort: "id desc, emissao desc, vencimento desc",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
    };
  },
};
</script>

<style></style>
